// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".multi-scoped[data-v-988ed5ac] .multiselect__tags{border:1px solid #ced4da}", ""]);
// Exports
module.exports = exports;
